import client from '@lib/services/client';

export const paging = client.api.auditLogControllerFindByEnvironmentAndCreatedAtBetween;
